import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useHistory } from 'react-router-dom';
import language from '../../../../helpers/language';
import { useSelector, useDispatch } from 'react-redux';
import { clearNotification, fetchAllNotification } from '../../../home/modules/HomeModule';
import firebase from '../../../../config/firebase';
  import FormSpinner from '../../../../components/Spinners/FormSpinner';

export default function BuyerHeader(props) {
    const notificationRef = useRef();
    const history = useHistory();
    const [showNotif, SetShowNotif] = useState(false);
    const [lang] = useState(language.getLang());
    const dispatch = useDispatch();
    const [notificationCount, setNotificationCount] = useState(0);
    const [userNodeData, setUserNodeData] = useState({});
    const currentUser = JSON.parse(localStorage.getItem("USER_TYPE")) ?? null;
    const { notificationData, getNotificationSpinner } = useSelector((state) => state.activityFeedStatus);
    useEffect(async () => {
        await getUserNode();
      }, [currentUser?.user_id]);

      console.log(notificationCount,"showNotifshowNotif")
    const getUserNode = async () => {
    const userId = await currentUser?.user_id;
    if (userId) {
        const fetchUserNode = firebase.database().ref('users').child(userId);
        fetchUserNode.on('value', async (snapshot) => {
        const response = snapshot.val();
        console.log(fetchUserNode,"fetchUser")
        console.log(response,"response-Notification");
        await setNotificationCount(response?.notification);
        await setUserNodeData(response);
        });
    }
    };

    const handleNotification = async () => {
    await SetShowNotif(!showNotif);
    await dispatch(fetchAllNotification(1)).then((result) => {
        if (result) {
        if (userNodeData?.notification) {
            userNodeData.notification = 0;
            const userId = currentUser?.user_id;
            firebase.database().ref('users').child(userId).set(userNodeData);
        }
        }
    });
    };

    const redirectTo = (item) => {
        parseInt(item?.notification_type) === 15 &&  history.push(`${'/view-recent-request/'}${item?.redirect_to_id}`);
    }
    
    const removeNotification = async () => {
        await SetShowNotif(!showNotif);
        await dispatch(clearNotification());
      };

      useEffect(() => {
        const closeNotificationPopUp = (event) => {
          if (
            notificationRef.current &&
            !notificationRef.current.contains(event.target)
          ) {
            SetShowNotif(false);
          }
        };
        document.body.addEventListener('click', closeNotificationPopUp);
    
        return () =>
          document.body.addEventListener('click', closeNotificationPopUp);
      }, [notificationRef]);

      

    
    return (
        <>
            <section className='buyerDashboard'>
                <div className='headerView'>
                    <div className='pageTitle'>
                        {props.pageTitle &&
                            <h4>{props.pageTitle}</h4>
                        }
                    </div>
                    <div  className='notificationView cursor-pointer relative' onClick={() => handleNotification()}>
                    <Link to="#" ref={notificationRef}>
                    {notificationCount !== undefined &&
                        notificationCount !== 0 && (
                          <Fragment>
                            {notificationCount <= 10 && (
                              <p className="noti_no">{notificationCount}</p>
                            )}
                            {notificationCount > 10 && (
                              <p className="noti_no largeNotiNo">
                                10{' '}
                                <i
                                  className="fa fa-plus"
                                  aria-hidden="true"
                                ></i>
                              </p>
                            )}
                          </Fragment>
                        )}
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2C11.172 2 10.5 2.672 10.5 3.5V4.19531C7.91318 4.86209 6 7.2048 6 10V16L4 18V19H10.2695C10.0934 19.3039 10.0005 19.6488 10 20C10 20.5304 10.2107 21.0391 10.5858 21.4142C10.9609 21.7893 11.4696 22 12 22C12.5304 22 13.0391 21.7893 13.4142 21.4142C13.7893 21.0391 14 20.5304 14 20C13.9989 19.6486 13.9053 19.3037 13.7285 19H20V18L18 16V10C18 7.2048 16.0868 4.86209 13.5 4.19531V3.5C13.5 2.672 12.828 2 12 2ZM12 6C14.206 6 16 7.794 16 10V16V16.8281L16.1719 17H7.82812L8 16.8281V16V10C8 7.794 9.794 6 12 6Z" fill="black"></path></svg>

                    </Link>
                    
                    </div>

                    {/* Notification Data Show */}
                    {showNotif &&
                        <div className="card card--block modal_box notification">
                            <div className="flex justify-between items-center mb-3 notification-header">
                                <h4 className="page__title">Notification</h4>
                                <Link to="#" onClick={() => removeNotification()}>
                                    {' '}
                                    {lang?.Clear_All}
                                </Link>
                            </div>

                            <div className="notification--scroll">
                            {getNotificationSpinner ? (
                            <FormSpinner />
                            ) : (
                            <Fragment>
                            {notificationData &&
                            notificationData.data &&
                            notificationData.data.length > 0 ? (
                            notificationData.data.map((item, index) => {
                            return (
                            <Fragment key={index}>
                            <div className="feed-user-info home_page noti mb-1">
                            <div
                            className="user__pic"
                            onClick={() => redirectTo(item)}
                            >
                            {item && item.user ? (
                                <img
                                src={`${item.user.base_url}${item.user.avatar_image}`}
                                alt="Profile image"
                                />
                            ) : (
                                <img
                                src="https://source.unsplash.com/user/c_v_r"
                                alt="Profile image"
                                />
                            )}
                            </div>

                            <div className="user__detail-data w-full tested">
                            <div className="flex">
                                <span
                                className="user__name"
                                onClick={() => redirectTo(item)}
                                >
                                <Link to="#">
                                    <strong>{item.sender_name}</strong>
                                </Link>
                                </span>
                            </div>
                            <span className="user__name">{item.title}</span>
                            <div className="just__Now text-right">
                                {item?.posted_at}
                            </div>
                            </div>
                            </div>
                            <hr />
                            </Fragment>
                            );
                            })
                            ) : (
                            <div className="empty_notification">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="m-auto"
                            width="63.185"
                            height="67.363"
                            viewBox="0 0 63.185 67.363"
                            >
                            <path
                            id="icons8_notification_2"
                            d="M36.205,4a3.6,3.6,0,0,0-3.228,1.992L31.361,9.23A18.071,18.071,0,0,0,17.245,24.619l-2.613,20.92A10.846,10.846,0,0,1,12.9,50.2L7.345,58.535a3.608,3.608,0,0,0,3,5.611H30a8.412,8.412,0,0,0,16.653,0h19.66a3.612,3.612,0,0,0,3-5.611L63.76,50.2a10.846,10.846,0,0,1-1.734-4.661l-2.613-20.92A18.07,18.07,0,0,0,45.3,9.23L43.681,5.992A3.6,3.6,0,0,0,40.453,4Zm0,2.406h4.248a1.186,1.186,0,0,1,1.071.667l.893,1.781c-.305-.014-.6-.042-.912-.042H35.153c-.305,0-.606.028-.912.042l.893-1.781A1.185,1.185,0,0,1,36.205,6.406Zm-1.053,4.812h6.353a15.66,15.66,0,0,1,15.516,13.7l2.617,20.924a13.272,13.272,0,0,0,2.119,5.695l5.554,8.331a1.2,1.2,0,0,1-1,1.875H10.343a1.2,1.2,0,0,1-1-1.87l5.169-7.753H48.155a1.2,1.2,0,0,0,0-2.406H15.892a13.288,13.288,0,0,0,1.128-3.872l2.612-20.924A15.665,15.665,0,0,1,35.153,11.217Zm5.432,3.609a1.2,1.2,0,0,0,0,2.406,9.323,9.323,0,0,1,5.944,2.138,1.2,1.2,0,1,0,1.537-1.856A11.764,11.764,0,0,0,40.585,14.826Zm9.572,6.2a1.157,1.157,0,0,0-.46.108,1.2,1.2,0,0,0-.6,1.588,9.339,9.339,0,0,1,.785,3.035,1.2,1.2,0,0,0,1.2,1.095.762.762,0,0,0,.1,0,1.2,1.2,0,0,0,1.095-1.306,11.681,11.681,0,0,0-.992-3.806A1.208,1.208,0,0,0,50.156,21.029Zm2.509,28.682a1.2,1.2,0,0,0,0,2.406h5.112a1.2,1.2,0,0,0,0-2.406ZM14.271,54.522a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,14.271,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,20.285,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,26.3,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,1,0,2.406,0V55.725A1.205,1.205,0,0,0,32.315,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,38.329,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,44.344,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,50.358,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,56.373,54.522Zm6.015,0a1.205,1.205,0,0,0-1.2,1.2v2.406a1.2,1.2,0,0,0,2.406,0V55.725A1.205,1.205,0,0,0,62.388,54.522ZM32.437,64.146H44.222a6.014,6.014,0,0,1-11.785,0Z"
                            transform="translate(-6.737 -4)"
                            />
                            </svg>
                            <h4 className="font-18 text-black">
                            {lang?.no_notifications}
                            </h4>
                            </div>
                            )}
                            {notificationData?.total > 10 && (
                            <div className="just__Now viewAll">
                            <Link to="/buyer-notification" className="btn">
                            {lang?.View_all} {lang?.Notifications}
                            </Link>
                            </div>
                            )}
                            </Fragment>
                            )}
                            </div>
                        </div>
                    }
                </div>
            </section >
        </>
    )
}
